import { BillingInvoice } from "../api/getBillingInvoices/types";
import { BILLING_STATUS_COLORS } from "./billingStatusColors";

export const BILLING_INVOICE_STATUS_LABELS: Record<
  BillingInvoice["status"],
  string
> = {
  paid: "Paid",
  open: "Open",
  past_due: "Past due",
};

export const BILLING_INVOICE_STATUS_COLORS: Record<
  BillingInvoice["status"],
  string
> = {
  paid: BILLING_STATUS_COLORS.green,
  open: BILLING_STATUS_COLORS.grey,
  past_due: BILLING_STATUS_COLORS.red,
};
